module.exports = __webpack_public_path__ + "static/img/弹窗-大气.e458c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/弹窗-大气.png
// module id = Yv9g
// module chunks = 3